import { render, staticRenderFns } from "./PosterTimeline.vue?vue&type=template&id=404c85de&scoped=true"
import script from "./PosterTimeline.vue?vue&type=script&lang=js"
export * from "./PosterTimeline.vue?vue&type=script&lang=js"
import style0 from "./PosterTimeline.vue?vue&type=style&index=0&id=404c85de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c85de",
  null
  
)

export default component.exports